import sliceReducer from "./slice"
import { configureStore } from "@reduxjs/toolkit"; 
export default configureStore({
    reducer:{
     slice:sliceReducer,
     
    }
})